import { DEFAULT_LANGUAGE, SUPPORTED_LANGUAGES } from '@/constants/tran';

import { i18n } from './i18n';
import store from '../store';

export const getLanguageFromLS = () => {
  const { contract_id, event_code } = store.state;
  const keyStore = contract_id + event_code;

  const objFromLS =
    localStorage.getItem(keyStore) !== null
      ? JSON.parse(localStorage.getItem(keyStore))
      : null;

  return objFromLS.sekisho_lang || null;
};

export const setLanguageFromLS = async (_lang) => {
  const { contract_id, event_code } = store.state;
  const keyStore = contract_id + event_code;

  const objFromLS =
    localStorage.getItem(keyStore) !== null
      ? JSON.parse(localStorage.getItem(keyStore))
      : null;

  const newObj = {
    ...objFromLS,
    sekisho_lang: _lang
  };

  localStorage.setItem(keyStore, JSON.stringify(newObj));
};

const Trans = {
  get defaultLanguage() {
    return DEFAULT_LANGUAGE;
  },

  get supportedLanguages() {
    return SUPPORTED_LANGUAGES;
  },

  get currentLanguage() {
    if (localStorage.getCurrentLanguage) {
      return getLanguageFromLS();
    }
    return i18n.locale;
  },

  set currentLanguage(lang) {
    i18n.locale = lang;
    return setLanguageFromLS(lang);
  },

  isLangSupported(lang) {
    return Trans.supportedLanguages.includes(lang);
  },

  loadLanguageFile(lang) {
    return import(
      /* webpackChunkName: "lang-[request]" */ `@/lang/${lang}.json`
    );
  },

  setI18nLanguageInServices(lang) {
    Trans.currentLanguage = lang;

    document.querySelector('html').setAttribute('lang', lang);
  },

  changeLanguage(lang) {
    if (!Trans.isLangSupported(lang))
      return Promise.reject(new Error('Ngôn ngữ không được hỗ trợ'));
    if (i18n.locale === lang) return Promise.resolve(lang);
    return Trans.loadLanguageFile(lang).then((msgs) => {
      i18n.setLocaleMessage(lang, msgs.default || msgs);
      Trans.setI18nLanguageInServices(lang);
    });
  }
};

export { Trans };
